import styled from 'styled-components';

import OutputText from '@ey/canvascoreservices/OutputText';

import {applyAvatarSize} from '../StyledAvatar';

export default styled(OutputText)`
	${applyAvatarSize}
	background: var(--person-avatar-bg);
	color: var(--person-avatar-co);
	display: flex;
	justify-content: center;
	align-items: center;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	font-size: calc(var(--person-avatar-size, 24px) * 0.4);
	font-weight: 400;
`;
